<template>
  <div class="resource_course_wrap">
    <div class="left_box">
      <div class="resource_course_title">{{atlasName}}</div>
      <div class="resource_course_box" :style="`height: ${windowHeight - 140}px;`">
        <el-tree :data="subjectTree" :props="defaultProps" :expand-on-click-node="false" :default-expanded-keys="[showTreeId]" node-key="id" @node-click="handleNodeClick"></el-tree>
      </div>
    </div>
    <div class="right_box">
      <router-view :select-tree-id="showTreeId" :top-tree-id="topTreeId" :select-dom-name="showTreeDomName" @change-tree="changeTreeList"></router-view>
    </div>
  </div>
</template>

<script>
  import windowResize from '@/mixins/windowResize';
  import {findGradeAtlasDetailList} from '@/api/resourceMap'

  export default {
    name: "resourceCourseIndex",
    data() {
      return {
        atlasId: sessionStorage.getItem('atlasId'),
        atlasName: this.$route.query.atlasName,
        defaultProps: {
          children: 'childrenList',
          label: 'name'
        },
        subjectTree: [],
        topTreeId: '1',
        showTreeId: '1',
        showTreeDomName: '',
        isChangeTree: false
      }
    },
    mixins: [windowResize],
    created() {
      this.findGradeAtlasDetailList();
    },
    methods: {
      goBack() {
        this.$router.go(-1);
      },
      handleNodeClick(data) {
        this.showTreeId = data.id;
        this.showTreeDomName = data.name;
        if (this.$route.path !== '/main/systemMaintain/study/resourceMap/resourceCourse/list') {
          this.$router.go(-1);
        }
      },
      findGradeAtlasDetailList() {
        findGradeAtlasDetailList({pidAtlasId: this.atlasId}).then(data => {
          this.subjectTree = data;
          if (data.length && !this.isChangeTree) {
            this.topTreeId = data[0].id;
            this.showTreeId = data[0].id;
            this.showTreeDomName = data[0].name;
          }
          this.isChangeTree = false;
        })
      },
      changeTreeList(menuName) {
        this.isChangeTree = true;
        this.showTreeDomName = menuName || this.subjectTree[0].name;
        if (!menuName) this.showTreeId = this.subjectTree[0].id;
        this.findGradeAtlasDetailList();
      }
    }
  }
</script>

<style>
  .resource_course_wrap .el-menu-item {
    height: 36px;
    line-height: 36px;
  }

  .resource_course_wrap .el-menu {
    border-right-width: 0;
  }
</style>
<style lang="scss" scoped>
  @import './../../../styles/mixin';

  .resource_course_wrap {
    height: 100%;
    padding: 12px;
    display: flex;
    box-sizing: border-box;

    .left_box {
      width: 180px;
      height: 100%;
      border-right: 1px solid #eee;
      overflow: hidden;

      .resource_course_title {
        height: 30px;
        line-height: 30px;
        padding-left: 20px;
        font-size: 20px;
        font-weight: bold;
      }

      .resource_course_box {
        @include scrollBar;
      }
    }

    .right_box {
      flex: 1;
      overflow: hidden;

    }
  }
</style>



// WEBPACK FOOTER //
// src/views/study/resourceMap/resourceCourseIndex.vue